<template>
    <div class="content-wrapper primary-table form-table">
        <div class="row">
            <div class="col-sm-12 d-md-none">
                <app-breadcrumb :page-title="$t('form_short')" :directory="$t('datatables')" :icon="'grid'"/>
            </div>

            <div class="col-sm-12 col-md-12 breadcrumb-side-button-add">
                <div class="float-md-right mt-1 mb-sm-3 mb-md-0 text-right guide-step-forms-4">
                    <button type="button"
                            class="btn btn-primary btn-with-shadow"
                            data-toggle="modal"
                            @click="openAddEditModal">
                        <i class="custom-icon custom-icon-button-inline custom-icon-plus"></i>
                        {{ $t('add') }}

                    </button>
                </div>
            </div>

        </div>

        <app-table
            :id="tableId"
            :options="options"
            :filtered-data="filteredData"
            @getRows="getSelectedRows"
            @getRowsAction="getSelectedRowsAction"
            @getAddButtonAction="openAddEditModal"
            @action="getListAction"
        />

        <app-form-add-modal
            v-if="isAddEditModalActive"
            :table-id="tableId"
            :selected-url="selectedUrl"
            :modal-type="modalType"
            @close-modal="closeAddEditModal"
            @close-and-open-modal="closeAddEditModalAndOpen"
        />


        <!-- Delete nema jit natvrdo, at nezmizi pozice ze systemu. Jen skryt zobrazeni v datatable -->
        <app-delete-modal
            v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            modal-id="demo-delete"
            @confirmed="confirmed"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import {TableHelpers} from './mixins/TableHelpers';

export default {
    extends: CoreLibrary,
    name: "DatatableWithFilter",
    mixins: [TableHelpers],
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            shareModalActive: false,
            rejectionModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            selectedCandidates: '',
            modalType: 'add-edit-modal',
            tableId: 'quiz',
            filteredData: {
                name: '',
            },
            rowData: {},
            options: {
                name: 'FormTable',
                url: actions.DATATABLE_FORMS_DATA,
                showHeader: true,
                columns: [],
                actions: [

                        {
                            title: this.$t('edit'),
                            icon: 'edit-3',
                            type: 'none',
                            className: 'edit ml-4',
                            component: 'app-form-add-modal',
                            modalId: 'add-edit-Modal',

                        },
                        // {
                        //     title: this.$t('delete'),
                        //     icon: 'trash',
                        //     type: 'none',
                        // }
                ],

                filters: [

                    {
                        "title": this.$t('course_visibility'),
                        "type": "radio",
                        "key": "filter-with-status-id",
                        "initValue": '1',
                        "header": {
                            "title":this.$t('course_visibility'),
                        },
                        "option": [
                            {
                                id: '1',
                                name: this.$t('displayed_to_atendees'),
                            },
                            {
                                id: '2',
                                name: this.$t('inactive_courses'),
                            },
                            {
                                id: '3',
                                name: this.$t('deleted_courses'),
                            },
                        ],
                        listValueField: 'name'
                    },

                    {
                        "title": "Category",
                        "type": "hidden",
                        "key": "filter-with-category",
                        "initValue": "quiz", // quiz, feedback, course-quiz, document, message
                        "option": [],
                    },

                    {
                        "title": this.$t('timeline_course_date'),
                        "type": "drop-down-filter",
                        "key": "filter-with-timeline-state",
                        "option": [
                            {id: '7', value: 'Před nástupem'},
                            {id: '7', value: 'Před nástupem'},
                            {id: '8', value: 'První den'},
                            {id: '9', value: 'Zkušební doba'},
                            {id: '10', value: 'Zaměstnání'},
                            {id: '11', value: 'Povýšení'},
                            {id: '12', value: 'Mateřská'},
                            {id: '13', value: 'Offboarding'},
                        ],
                        "initValue": ''
                    },
                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 20,
                showAction: true,
                actionSelectOptions: [
                    {id: '1', value: this.$t('reject_candidate')},
                    {id: '2', value: this.$t('share_with_manager')},
                    {id: '3', value: this.$t('change_state...')},
                    // {id: '4', value: this.$t('start_hiring')},
                    {id: '5', value: this.$t('start_onboarding')},
                ],
                actionSelectedOption: 1,
                timelineState: [
                    {id: '0', value: 'Vyberte'},
                    {id: '7', value: 'Před nástupem'},
                    {id: '8', value: 'První den'},
                    {id: '9', value: 'Zkušební doba'},
                    {id: '10', value: 'Zaměstnání'},
                    {id: '11', value: 'Povýšení'},
                    {id: '12', value: 'Mateřská'},
                    {id: '13', value: 'Offboarding'},
                ],
                timelineSelectedState: 0,
                orderBy: 'desc',
                actionType: "default",
                tableShadow: false,
                emptyText: this.$t('nothing_to_show_here_hiring'),
                showEmptyAnimation: true,
                showComments: false,
                showTopBar: false,
                showTimeline: false,
                showAddButton: false,
                datatableParentId: 0, // 3=onboarding, 2=hiring, 1=talentpool, 0=forms
                // actionType: "dropdown",
                enableRowSelect: false,
                // tablePaddingClass: 'p-primary'
                tableClass: 'primary-table',

                currentMainTab: 3,
                mainTabs: [
                    {page: actions.DATATABLE_ONBOARDING_URL, pageName: this.$t('people'),className:'guide-step-checklist-2'},
                    {page: actions.DATATABLE_ONBOARDING_CHECKLIST_URL, pageName: this.$t('my_tasks'),className:'guide-step-checklist-1'},
                    {page: '../onboarding/stranka?id=1&job=1', pageName: this.$t('onboarding_site'),className:'guide-step-checklist-3'},
                    {page: '../onboarding/forms/', pageName: this.$t('forms'),className:'guide-step-checklist-4'},
                ],


            },

        }
    },
    created() {
        this.options.columns = [...this.tableColumns, this.actionObj];
        this.searchAndSelectFilterOptions();

        /**
         * Open modal after clicking on notification and etc.
         */
        if(this.getDefaultForm()){
            if(this.getDefaultForm() == 'new'){
                this.selectedUrl = ``;
            } else {
                this.selectedUrl = `${actions.DATATABLE_FORMS_DATA}/${this.getDefaultForm()}`;
            }

            this.openAddEditModal();
        }

    },
    methods: {

        /**
         * Modals
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },
        openRejectionModal() {
            this.rejectionModalActive = true;
        },
        openShareModal() {
            this.shareModalActive = true;
        },
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },
        closeAddEditModal() {
            $("#add-edit-Modal").modal('hide');
            this.isAddEditModalActive = false;
            this.searchAndSelectFilterOptions();
            this.reSetData();

            // Add page after visited candidate to history
            if (history.replaceState) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                window.history.replaceState({path:newurl},'',newurl);
            }
        },
        closeRejectionModal() {
            this.rejectionModalActive = false;
            this.reSetData();
            console.log('close modal');
        },
        closeShareModal() {
            this.shareModalActive = false;
            this.reSetData();
            console.log('close modal');
        },
        closeAddEditModalAndOpen(modal, candidate) {
            this.closeAddEditModal();

            if(modal == 'notification'){
                this.selectedRows = candidate;
                this.openShareModal();
            } else if (modal == 'rejection'){
                this.selectedRows = candidate;
                this.openRejectionModal();
            }

        },


        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;

            if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.DATATABLE_FORMS_DATA}/${rowData.id}`;
                this.openAddEditModal();
            }
        },


        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.DATATABLE_FORMS_DATA}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#demo-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                    this.searchAndSelectFilterOptions();
                }).catch(({error}) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
        searchAndSelectFilterOptions() {
            this.getTimelineStateNames();
        },


        /**
         * Actions
         */

        getUrlParameter(name, url) {
            if (!url) url = location.href;
            name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
            var regexS = "[\\?&]"+name+"=([^&#]*)";
            var regex = new RegExp( regexS );
            var results = regex.exec( url );
            return results == null ? null : results[1];
        },
        getCookie(name) {
            var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
            return match ? match[1] : null;
        },
        getDefaultForm(){
            if(location.href.indexOf("?form") >= 0){
                return parseInt(this.getUrlParameter('form', location.href));
            } else if (location.href.indexOf("?new") >= 0){
                return 'new';
            }
        },
        getSelectedRows(value) {
            this.selectedRows = value;
        },
        getSelectedRowsAction() {

        },
        getSearchValue(value) {
            let instance = this;
            this.search = value;
            setTimeout(function () {
                instance.$hub.$emit('reload-' + instance.tableId);
            });
        },
        getFilterValue(item) {
            this.filteredData.status = item;
            console.log('test '+item);
            this.$hub.$emit('reload-'+this.tableId);
        },


        /**
         * Get additional data
         */
        getTimelineStateNames() {

            this.axiosGet(actions.TIMELINE_STATES_DATA+'?status=3').then(response => {
                if(response.data.length){
                    this.options.timelineState = response.data;
                } else {
                    this.options.timelineState = response.data;
                }


            });

        },


        /**
         * Save basic data
         */

        afterSuccess(response) {
            this.$hub.$emit('reload-' + this.tableId);
            this.$toastr.s(this.$t(response.data));

        },
        afterError(response) {
            this.$hub.$emit('reload-' + this.tableId);
            this.$toastr.s(this.$t(response.data));

        },



    },
}
</script>
